export type Unit = 'KG' | 'G' | 'L' | 'ML' | 'PC' | 'UN';

export const allUnits: Unit[] = ['KG', 'G', 'L', 'ML', 'PC', 'UN'];

const compatibleUnits: Record<Unit, Unit[]> = {
    KG: ['KG'],
    G: ['G', 'KG'],
    L: ['L'],
    ML: ['ML', 'L'],
    UN: ['UN', 'PC'],
    PC: ['PC', 'UN'],
};

const unitTypes: Record<Unit, 'mass' | 'volume' | 'unit'> = {
    KG: 'mass',
    G: 'mass',
    L: 'volume',
    ML: 'volume',
    PC: 'unit',
    UN: 'unit',
};

const baseConversions: Record<Unit, number> = {
    KG: 1,
    G: 0.001,
    L: 1,
    ML: 0.001,
    PC: 1,
    UN: 1,
};

type Insume = {
    name: string;
    qtd: number;
    unit: string;
    insume: string;
};

export const convertInsumeQtd = (defaultUnit: Unit, unit: Unit, qtd: number): number => {
    if (!defaultUnit || !unit || isNaN(qtd) || qtd < 0) {
        throw new Error('Unidade padrão, unidade informada ou quantidade inválida');
    }

    const fromType = unitTypes[unit];
    const toType = unitTypes[defaultUnit];

    if (fromType !== toType) {
        throw new Error(`Conversão entre tipos diferentes (${unit} → ${defaultUnit}) não é permitida`);
    }

    const fromRate = baseConversions[unit];
    const toRate = baseConversions[defaultUnit];

    return qtd * (fromRate / toRate);
};

export const getMultiplierCMV = (unit?: Unit) => {
    return (unit !== 'PC' && unit !== 'UN' ? 1000 : 1)
}

export const convertGramaToKg = (unit: Unit, qtd: number) => {
    return qtd
}

export const getMediumPriceCMV = (priceTotal = 0, qtd = 0, unit?: Unit) => {
    const value = priceTotal === 0 ? 0 : (priceTotal / qtd)
    return value
}

export const getFullValueCMV = (priceTotal: number, unit?: Unit) => {
    const total = priceTotal
    const formatedValue = (total / 100).toFixed(2)
    return Number(formatedValue)
}

export const getTotalMediumPrice = (priceTotal = 0, qtd = 0, multiply = true) => {
    const total = priceTotal * qtd
    return (total / (multiply ? 100 : 1)).toFixed(2)
}

export const dividePerMlOrKgCMV = (value: number | string, unit: Unit) => {
    value = Number(value)
    if (value === 0 || !value) return 0;
    const divisor = unit === "PC" || unit === "UN" ? 1 : 1000
    return value / divisor
}

export const MultiplierPerMlOrKgCMV = (value: number | string, unit: Unit) => {
    value = Number(value)
    if (value === 0 || !value) return 0;
    const multiplier = unit === "PC" || unit === "UN" ? 1 : 1000
    return value * multiplier
}

export const getFloatCMV = (value: number | string = 0): number | string => {
    const val = Number(value);
    if (Number.isInteger(val)) return val;
    return val.toFixed(3);
};

export const arraysIguais = (a: Insume[], b: Insume[]): boolean => {
    if (a.length !== b.length) return false;
    return a.every((item, i) => {
        const other = b[i];
        return (
            item.name === other.name &&
            item.qtd === other.qtd &&
            item.unit === other.unit &&
            item.insume === other.insume
        );
    });
}

export const getCompatibleUnits = (defaultUnit: Unit): { value: Unit; text: string }[] => {
    const units = compatibleUnits[defaultUnit] || [];
    return units.map(unit => ({
        value: unit,
        text: unit,
    }));
};
